<script>
import { KohlerMilestone } from "../../../core/kohler-milestones";
import AutobuyerBox from "./AutobuyerBox";
import AutobuyerDropdownEntry from "./AutobuyerDropdownEntry";
import AutobuyerInput from "./AutobuyerInput";
import AutobuyerIntervalButton from "./AutobuyerIntervalButton";
import ExpandingControlBox from "@/components/ExpandingControlBox";

export default {
  name: "MendingAutobuyerBox",
  components: {
    AutobuyerBox,
    AutobuyerIntervalButton,
    AutobuyerInput,
    ExpandingControlBox,
    AutobuyerDropdownEntry
  },
  props: {
    isModal: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      isDoomed: false,
      hasMaxedInterval: true,
      mode: AUTO_MEND_MODE.AMOUNT,
      hasAdditionalModes: false,
      increaseWithMult: true,
    };
  },
  computed: {
    autobuyer: () => Autobuyer.mending,
    modes: () => {
      let x = [AUTO_MEND_MODE.AMOUNT, AUTO_MEND_MODE.TIME];
      //if (KohlerMilestone(21).isUnlocked) x.push(AUTO_MEND_MODE.AMOUNT_KP);
      return x;
    },
    amountMode: () => AUTO_MEND_MODE.AMOUNT
  },
  watch: {
    increaseWithMult(newValue) {
      this.autobuyer.increaseWithMult = newValue;
    }
  },
  methods: {
    update() {
      this.isDoomed = Pelle.isDoomed;
      this.hasMaxedInterval = this.autobuyer.hasMaxedInterval;
      this.mode = this.autobuyer.mode;
      this.hasAdditionalModes = this.autobuyer.hasAdditionalModes;
      this.increaseWithMult = this.autobuyer.increaseWithMult;
    },
    modeProps(mode) {
      switch (mode) {
        case AUTO_MEND_MODE.AMOUNT: return {
          title: "Mend at X MvR",
          input: {
            property: "amount",
            type: "decimal"
          },
        };
        case AUTO_MEND_MODE.TIME: return {
          title: "Seconds between Mends",
          input: {
            property: "time",
            type: "float"
          },
        };
        case AUTO_MEND_MODE.AMOUNT_KP: return {
          title: "Mend at X KP",
          input: {
            property: "amount",
            type: "decimal"
          },
        };
      }
      throw new Error("Unknown Auto Mend mode");
    },
    modeName(mode) {
      return this.modeProps(mode).title;
    },
  }
};
</script>

<template>
  <AutobuyerBox
    :autobuyer="autobuyer"
    :show-interval="false"
    :is-modal="isModal"
    name="Automatic Mends"
  >
    <template
      #intervalSlot
    >
      <ExpandingControlBox
        v-if="hasAdditionalModes"
        :auto-close="true"
      >
        <template #header>
          <div class="o-primary-btn c-autobuyer-box__mode-select c-autobuyer-box__mode-select-header">
            ▼ Current Setting: ▼
            <br>
            {{ modeName(mode) }}
          </div>
        </template>
        <template #dropdown>
          <AutobuyerDropdownEntry
            :autobuyer="autobuyer"
            :modes="modes"
            :mode-name-fn="modeName"
          />
        </template>
      </ExpandingControlBox>
      <span v-else>
        {{ modeProps(mode).title }}:
      </span>
    </template>
    <template
      #toggleSlot
    >
      <AutobuyerInput
        :key="mode"
        :autobuyer="autobuyer"
        v-bind="modeProps(mode).input"
      />
    </template>
  </AutobuyerBox>
</template>

<style scoped>
.o-clickable {
  cursor: pointer;
}
</style>
